const countries = [
  { value: "AF", label: "Afghanistan", icon: "af.png" },
  { value: "AL", label: "Albania", icon: "al.png" },
  { value: "DZ", label: "Algeria", icon: "dz.png" },
  { value: "AS", label: "American Samoa", icon: "as.png" },
  { value: "AD", label: "Andorra", icon: "ad.png" },
  { value: "AO", label: "Angola", icon: "ao.png" },
  { value: "AI", label: "Anguilla", icon: "ai.png" },
  { value: "AG", label: "Antigua and Barbuda", icon: "ag.png" },
  { value: "AR", label: "Argentina", icon: "ar.png" },
  { value: "AM", label: "Armenia", icon: "am.png" },
  { value: "AW", label: "Aruba", icon: "aw.png" },
  { value: "AU", label: "Australia", icon: "au.png" },
  { value: "AT", label: "Austria", icon: "at.png" },
  { value: "AZ", label: "Azerbaijan", icon: "az.png" },
  { value: "BS", label: "Bahamas", icon: "bs.png" },
  { value: "BD", label: "Bangladesh", icon: "bd.png" },
  { value: "BB", label: "Barbados", icon: "bb.png" },
  { value: "BY", label: "Belarus", icon: "by.png" },
  { value: "BE", label: "Belgium", icon: "be.png" },
  { value: "BZ", label: "Belize", icon: "bz.png" },
  { value: "BJ", label: "Benin", icon: "bj.png" },
  { value: "BM", label: "Bermuda", icon: "bm.png" },
  { value: "BT", label: "Bhutan", icon: "bt.png" },
  { value: "BO", label: "Bolivia, Plurinational State of", icon: "bo.png" },
  { value: "BA", label: "Bosnia and Herzegovina", icon: "ba.png" },
  { value: "BW", label: "Botswana", icon: "bw.png" },
  { value: "BR", label: "Brazil", icon: "br.png" },
  { value: "IO", label: "British Indian Ocean Territory", icon: "io.png" },
  { value: "BG", label: "Bulgaria", icon: "bg.png" },
  { value: "BF", label: "Burkina Faso", icon: "bf.png" },
  { value: "BI", label: "Burundi", icon: "bi.png" },
  { value: "KH", label: "Cambodia", icon: "kh.png" },
  { value: "CM", label: "Cameroon", icon: "cm.png" },
  { value: "CA", label: "Canada", icon: "ca.png" },
  { value: "CV", label: "Cape Verde", icon: "cv.png" },
  { value: "KY", label: "Cayman Islands", icon: "ky.png" },
  { value: "CF", label: "Central African Republic", icon: "cf.png" },
  { value: "TD", label: "Chad", icon: "td.png" },
  { value: "CL", label: "Chile", icon: "cl.png" },
  { value: "CN", label: "China", icon: "cn.png" },
  { value: "CO", label: "Colombia", icon: "co.png" },
  { value: "KM", label: "Comoros", icon: "km.png" },
  { value: "CG", label: "Congo", icon: "cg.png" },
  { value: "CD", label: "Democratic Republic of the Congo", icon: "cd.png" },
  { value: "CK", label: "Cook Islands", icon: "ck.png" },
  { value: "CR", label: "Costa Rica", icon: "cr.png" },
  { value: "CI", label: "Côte d'Ivoire", icon: "ci.png" },
  { value: "HR", label: "Croatia", icon: "hr.png" },
  { value: "CU", label: "Cuba", icon: "cu.png" },
  { value: "CW", label: "Curaçao", icon: "cw.png" },
  { value: "CY", label: "Cyprus", icon: "cy.png" },
  { value: "CZ", label: "Czech Republic", icon: "cz.png" },
  { value: "DK", label: "Denmark", icon: "dk.png" },
  { value: "DJ", label: "Djibouti", icon: "dj.png" },
  { value: "DM", label: "Dominica", icon: "dm.png" },
  { value: "DO", label: "Dominican Republic", icon: "do.png" },
  { value: "EC", label: "Ecuador", icon: "ec.png" },
  { value: "EG", label: "Egypt", icon: "eg.png" },
  { value: "SV", label: "El Salvador", icon: "sv.png" },
  { value: "GQ", label: "Equatorial Guinea", icon: "gq.png" },
  { value: "ER", label: "Eritrea", icon: "er.png" },
  { value: "EE", label: "Estonia", icon: "ee.png" },
  { value: "ET", label: "Ethiopia", icon: "et.png" },
  { value: "FK", label: "Falkland Islands (Malvinas)", icon: "fk.png" },
  { value: "FO", label: "Faroe Islands", icon: "fo.png" },
  { value: "FJ", label: "Fiji", icon: "fj.png" },
  { value: "FI", label: "Finland", icon: "fi.png" },
  { value: "FR", label: "France", icon: "fr.png" },
  { value: "PF", label: "French Polynesia", icon: "pf.png" },
  { value: "GA", label: "Gabon", icon: "ga.png" },
  { value: "GM", label: "Gambia", icon: "gm.png" },
  { value: "GE", label: "Georgia", icon: "ge.png" },
  { value: "DE", label: "Germany", icon: "de.png" },
  { value: "GH", label: "Ghana", icon: "gh.png" },
  { value: "GI", label: "Gibraltar", icon: "gi.png" },
  { value: "GR", label: "Greece", icon: "gr.png" },
  { value: "GL", label: "Greenland", icon: "gl.png" },
  { value: "GD", label: "Grenada", icon: "gd.png" },
  { value: "GU", label: "Guam", icon: "gu.png" },
  { value: "GT", label: "Guatemala", icon: "gt.png" },
  { value: "GG", label: "Guernsey", icon: "gg.png" },
  { value: "GN", label: "Guinea", icon: "gn.png" },
  { value: "GW", label: "Guinea-Bissau", icon: "gw.png" },
  { value: "HT", label: "Haiti", icon: "ht.png" },
  { value: "HN", label: "Honduras", icon: "hn.png" },
  { value: "HK", label: "Hong Kong", icon: "hk.png" },
  { value: "HU", label: "Hungary", icon: "hu.png" },
  { value: "IS", label: "Iceland", icon: "is.png" },
  { value: "IN", label: "India", icon: "in.png" },
  { value: "ID", label: "Indonesia", icon: "id.png" },
  { value: "IR", label: "Iran, Islamic Republic of", icon: "ir.png" },
  { value: "IQ", label: "Iraq", icon: "iq.png" },
  { value: "IE", label: "Ireland", icon: "ie.png" },
  { value: "IM", label: "Isle of Man", icon: "im.png" },
  { value: "IL", label: "Israel", icon: "il.png" },
  { value: "IT", label: "Italy", icon: "it.png" },
  { value: "JM", label: "Jamaica", icon: "jm.png" },
  { value: "JP", label: "Japan", icon: "jp.png" },
  { value: "JE", label: "Jersey", icon: "je.png" },
  { value: "JO", label: "Jordan", icon: "jo.png" },
  { value: "KZ", label: "Kazakhstan", icon: "kz.png" },
  { value: "KE", label: "Kenya", icon: "ke.png" },
  { value: "KI", label: "Kiribati", icon: "ki.png" },
  { value: "KP", label: "North Korea", icon: "kp.png" },
  { value: "KR", label: "South Korea", icon: "kr.png" },
  { value: "KW", label: "Kuwait", icon: "kw.png" },
  { value: "KG", label: "Kyrgyzstan", icon: "kg.png" },
  { value: "LA", label: "Lao People's Democratic Republic", icon: "la.png" },
  { value: "LV", label: "Latvia", icon: "lv.png" },
  { value: "LB", label: "Lebanon", icon: "lb.png" },
  { value: "LS", label: "Lesotho", icon: "ls.png" },
  { value: "LR", label: "Liberia", icon: "lr.png" },
  { value: "LY", label: "Libya", icon: "ly.png" },
  { value: "LI", label: "Liechtenstein", icon: "li.png" },
  { value: "LT", label: "Lithuania", icon: "lt.png" },
  { value: "LU", label: "Luxembourg", icon: "lu.png" },
  { value: "MO", label: "Macao", icon: "mo.png" },
  { value: "MK", label: "Republic of Macedonia", icon: "mk.png" },
  { value: "MG", label: "Madagascar", icon: "mg.png" },
  { value: "MW", label: "Malawi", icon: "mw.png" },
  { value: "MY", label: "Malaysia", icon: "my.png" },
  { value: "MV", label: "Maldives", icon: "mv.png" },
  { value: "ML", label: "Mali", icon: "ml.png" },
  { value: "MT", label: "Malta", icon: "mt.png" },
  { value: "MH", label: "Marshall Islands", icon: "mh.png" },
  { value: "MQ", label: "Martinique", icon: "mq.png" },
  { value: "MR", label: "Mauritania", icon: "mr.png" },
  { value: "MU", label: "Mauritius", icon: "mu.png" },
  { value: "MX", label: "Mexico", icon: "mx.png" },
  { value: "FM", label: "Micronesia, Federated States of", icon: "fm.png" },
  { value: "MD", label: "Republic of Moldova", icon: "md.png"},
  { value: "MC", label: "Monaco", icon: "mc.png"},
  { value: "MN", label: "Mongolia", icon: "mn.png" },
  { value: "ME", label: "Montenegro", icon: "me.png" },
  { value: "MS", label: "Montserrat", icon: "ms.png" },
  { value: "MA", label: "Morocco", icon: "ma.png" },
  { value: "MZ", label: "Mozambique", icon: "mz.png" },
  { value: "MM", label: "Myanmar", icon: "mm.png" },
  { value: "NA", label: "Namibia", icon: "na.png" },
  { value: "NR", label: "Nauru", icon: "nr.png" },
  { value: "NP", label: "Nepal", icon: "np.png" },
  { value: "NL", label: "Netherlands", icon: "nl.png" },
  { value: "NZ", label: "New Zealand", icon: "nz.png" },
  { value: "NI", label: "Nicaragua", icon: "ni.png" },
  { value: "NE", label: "Niger", icon: "ne.png" },
  { value: "NG", label: "Nigeria", icon: "ng.png" },
  { value: "NU", label: "Niue", icon: "nu.png"},
  { value: "NF", label: "Norfolk Island", icon: "nf.png"},
  { value: "MP", label: "Northern Mariana Islands", icon: "mp.png"},
  { value: "NO", label: "Norway", icon: "no.png"},
  { value: "OM", label: "Oman" , icon: "om.png"},
  { value: "PK", label: "Pakistan" , icon: "pk.png"},
  { value: "PW", label: "Palau" , icon: "pw.png"},
  { value: "PS", label: "Palestinian Territory", icon: "ps.png"},
  { value: "PA", label: "Panama", icon: "pa.png"},
  { value: "PG", label: "Papua New Guinea", icon: "pg.png"},
  { value: "PY", label: "Paraguay", icon: "py.png"},
  { value: "PE", label: "Peru", icon: "pe.png"},
  { value: "PH", label: "Philippines", icon: "ph.png"},
  { value: "PN", label: "Pitcairn", icon: "pn.png"},
  { value: "PL", label: "Poland", icon: "pl.png"},
  { value: "PT", label: "Portugal", icon: "pt.png"},
  { value: "PR", label: "Puerto Rico", icon: "pr.png"},
  { value: "QA", label: "Qatar", icon: "qa.png"},
  { value: "RO", label: "Romania", icon: "ro.png"},
  { value: "RU", label: "Russian", icon: "ru.png"},
  { value: "RW", label: "Rwanda", icon: "rw.png"},
  { value: "KN", label: "Saint Kitts and Nevis", icon: "kn.png"},
  { value: "WS", label: "Samoa", icon: "ws.png"},
  { value: "SM", label: "San Marino", icon: "sm.png"},
  { value: "ST", label: "Sao Tome and Principe", icon: "st.png"},
  { value: "SA", label: "Saudi Arabia", icon: "sa.png"},
  { value: "SN", label: "Senegal", icon: "sn.png"},
  { value: "RS", label: "Serbia", icon: "rs.png"},
  { value: "SC", label: "Seychelles", icon: "sc.png"},
  { value: "SL", label: "Sierra Leone", icon: "sl.png"},
  { value: "SG", label: "Singapore", icon: "sg.png"},
  { value: "SX", label: "Sint Maarten", icon: "sx.png"},
  { value: "SK", label: "Slovakia", icon: "sk.png"},
  { value: "SI", label: "Slovenia", icon: "si.png"},
  { value: "SB", label: "Solomon Islands", icon: "sb.png"},
  { value: "SO", label: "Somalia", icon: "so.png"},
  { value: "ZA", label: "South Africa", icon: "za.png"},
  { value: "SS", label: "South Sudan", icon: "ss.png"},
  { value: "ES", label: "Spain", icon: "es.png"},
  { value: "LK", label: "Sri Lanka", icon: "lk.png"},
  { value: "SD", label: "Sudan", icon: "sd.png"},
  { value: "SR", label: "Suriname", icon: "sr.png"},
  { value: "SZ", label: "Swaziland", icon: "sz.png"},
  { value: "SE", label: "Sweden", icon: "se.png"},
  { value: "CH", label: "Switzerland", icon: "ch.png"},
  { value: "SY", label: "Syria", icon: "sy.png"},
  { value: "TW", label: "Taiwan, Province of China", icon: "tw.png"},
  { value: "TJ", label: "Tajikistan", icon: "tj.png"},
  { value: "TZ", label: "Tanzania", icon: "tz.png"},
  { value: "TH", label: "Thailand", icon: "th.png"},
  { value: "TG", label: "Togo", icon: "tg.png"},
  { value: "TK", label: "Tokelau", icon: "tk.png"},
  { value: "TO", label: "Tonga", icon: "to.png"},
  { value: "TT", label: "Trinidad and Tobago", icon: "tt.png"},
  { value: "TN", label: "Tunisia", icon: "tn.png"},
  { value: "TR", label: "Turkey", icon: "tr.png"},
  { value: "TM", label: "Turkmenistan", icon: "tm.png"},
  { value: "TC", label: "Turks and Caicos Islands", icon: "tc.png"},
  { value: "TV", label: "Tuvalu", icon: "tv.png"},
  { value: "UG", label: "Uganda", icon: "ug.png"},
  { value: "UA", label: "Ukraine", icon: "ua.png"},
  { value: "AE", label: "United Arab Emirates", icon: "ae.png"},
  { value: "UK", label: "United Kingdom", icon: "uk.png"},
  { value: "US", label: "United States", icon: "us.png"},
  { value: "UY", label: "Uruguay", icon: "uy.png"},
  { value: "UZ", label: "Uzbekistan", icon: "uz.png"},
  { value: "VU", label: "Vanuatu", icon: "vu.png"},
  { value: "VE", label: "Venezuela, Bolivarian Republic of", icon: "ve.png"},
  { value: "VN", label: "Viet Nam", icon: "vn.png"},
  { value: "VI", label: "Virgin Islands", icon: "vi.png"},
  { value: "YE", label: "Yemen", icon: "ye.png"},
  { value: "ZM", label: "Zambia", icon: "zm.png"},
  { value: "ZW", label: "Zimbabwe", icon: "zw.png"},
]

export default countries;